/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Debt_Fill_Col_FillInputs */

const vi_lot_debt_fill_col_fill = /** @type {(inputs: Lot_Debt_Fill_Col_FillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bù lần này`)
};

/**

* @param {Lot_Debt_Fill_Col_FillInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_debt_fill_col_fill = /** @type {((inputs?: Lot_Debt_Fill_Col_FillInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Debt_Fill_Col_FillInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_debt_fill_col_fill(inputs)
});